import React, {useState, useEffect} from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {components} from 'react-select';
import Select from 'react-select';
import {Field} from 'formik';
import LabelInput from '../LabelInput';
import arrowDown from '../../assets/arrow-down.svg';
import styles from './styles.module.scss';


const Control = props => <components.Control className={`${styles.control} ${props.isDisabled && styles.disabled}`} {...props}/>;

const DropdownIndicator = () => <img src={arrowDown} alt="dropdown arrow"/>;

const IndicatorsContainer = props => (
  <components.IndicatorsContainer className={styles.indicatorsContainer} {...props}/>
);

const Input = props => <components.Input className={styles.input} {...props}/>;

const Placeholder = props => <components.Placeholder className={styles.placeholder} {...props}/>;

const SingleValue = props => <components.SingleValue className={styles.input} {...props}/>;

const ValueContainer = props => <components.ValueContainer className={styles.valueContainer} {...props}/>;

const CustomSelect = ({
                        field,
                        form,
                        meta,
                        loadOptions,
                        containerStyles,
                        label,
                        placeholder,
                        onChange,
                        disabled,
                        isMulti,
                        ...rest
                      }) => {
  const [options, setOptions] = useState(null);
  const defaultPlaceholder = useIntl().formatMessage({
    id: 'common.form.input.select.placeholder',
    defaultMessage: 'Select...'
  });

  useEffect(() => {
    if (options === null) loadOptions("", setOptions);
  }, [loadOptions]);

  useEffect(() => {
    if (options === null) return;

    if (isMulti && (field.value instanceof Array)) {
      const mappedValues = field.value.map(payloadValue => {
        return options.filter(option => option.value === payloadValue.value)[0];
      });
      form.setFieldValue(field.name, mappedValues);
    } else {
      const selected = options.filter(option => option.value === field.value.value)[0];
      if (selected) form.setFieldValue(field.name, selected);
    }
  }, [options]);

  const handleChange = (form, field) => option => {
    form.setFieldValue(field.name, option);
    if (onChange) {
      onChange(option);
    }
  };

  return (
    <div className={classnames(styles.selectContainer, containerStyles)}>
      <div className={styles.label}>
        <LabelInput label={label} bold={false}/>
      </div>
      <Select
        options={options}
        defaultOptions
        className={classnames(styles.select, {[styles.errorBorder]: meta.error && meta.touched})}
        value={field.value}
        onChange={handleChange(form, field)}
        placeholder={placeholder || defaultPlaceholder}
        isSearchable={false}
        isDisabled={disabled}
        components={{
          Control,
          DropdownIndicator,
          IndicatorSeparator: null,
          IndicatorsContainer,
          Input,
          Placeholder,
          SingleValue,
          ValueContainer
        }}
        isMulti={isMulti}
        {...rest}
      />
    </div>
  )
};

const FieldSelect = ({
                       fieldId,
                       ...rest
                     }) => (
  <Field
    id={fieldId}
    name={fieldId}
  >
    {fieldProps => <CustomSelect {...fieldProps} {...rest} />}
  </Field>
);

FieldSelect.propTypes = {
  fieldId: PropTypes.string.isRequired,
  loadOptions: PropTypes.func.isRequired,
  label: PropTypes.node,
  placeholder: PropTypes.node,
  containerStyles: PropTypes.string,
  onChange: PropTypes.func,
};

export default FieldSelect;
